export interface AddressI {
    street?: string;
    city?: string;
    state?: string;
    zip?: string;
    country?: string;
    phone?: string;
    fax?: string;
    email?: string;
    addressType?: AddressType;

    [indexer: string]: string | number | undefined;
}

export enum AddressType {
    Admin = 1,
    Billing = 2,
    Work = 3,
    Home = 4,
}
